<template></template>

<script setup>
import { useToastNotifications } from "@/composables/useToastNotifications";
import { onMounted } from "vue";

const toast = useToastNotifications();
window.toast = toast;

const props = defineProps({
  messages: {
    type: String,
    required: true,
  },
});

onMounted(() => {
  setTimeout(() => {
    const messages = JSON.parse(props.messages);

    if (messages.success) {
      toast.success(messages.success);
    }

    if (messages.alert) {
      toast.error(messages.alert);
    }

    if (messages.notice) {
      toast.info(messages.notice);
    }

    if (messages.warning) {
      toast.warning(messages.warning);
    }
  }, 0);
});
</script>
